import { Trip } from '../../services/trips/api/tripsApi';
import { formatDestinations } from '../../services/trips/utils/tripUtils';
import { formatTripDates } from '../../services/trips/utils/dateUtils';
import { extractTripUuid } from '../../services/trips/utils/idUtils';

export interface ProfileTripPreview {
  id: string;
  title: string;
  meta: string;
  description: string;
  imageUrl: string;
  sourceTrip: Trip;
}

const fallbackTripImages = [
  'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?auto=format&fit=crop&w=900&q=80',
  'https://images.unsplash.com/photo-1513735492246-483525079686?auto=format&fit=crop&w=900&q=80',
  'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?auto=format&fit=crop&w=900&q=80',
  'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?auto=format&fit=crop&w=900&q=80',
];

export const mapTripToProfilePreview = (trip: Trip, index = 0): ProfileTripPreview => {
  const destinations = trip.destinations?.length ? trip.destinations : [];
  const duration = getTripDuration(trip);
  const dateRange = formatTripDates(trip.dates);
  const destinationLabel = destinations[0] || formatDestinations(destinations);
  const imageUrl = trip.images?.find((image) => /^https?:\/\//.test(image));

  return {
    id: extractTripUuid(trip.id),
    title: trip.title,
    meta: `${destinationLabel} · ${duration}`,
    description: trip.description || `${dateRange} across ${formatDestinations(destinations)}.`,
    imageUrl: imageUrl || fallbackTripImages[index % fallbackTripImages.length],
    sourceTrip: trip,
  };
};

const getTripDuration = (trip: Trip) => {
  if (!trip.dates?.startDate || !trip.dates?.endDate) return 'Dates TBD';

  const start = new Date(trip.dates.startDate);
  const end = new Date(trip.dates.endDate);
  const diff = Math.round((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1;

  if (!Number.isFinite(diff) || diff <= 0) {
    return 'Dates TBD';
  }

  return `${diff} ${diff === 1 ? 'day' : 'days'}`;
};
